import { useQuery } from '@tanstack/react-query';
import { saasApi } from '../api/saas.api';

export type LicensingReason =
  | 'OK'
  | 'TENANT_SUSPENDED'
  | 'NO_SUBSCRIPTION'
  | 'MACHINE_MISMATCH';

export interface LicensingCheckState {
  allowed: boolean;
  reason: LicensingReason;
  productCode: string;
}

/**
 * Hook to check licensing for a product. Calls POST /licensing/check with JWT + machineId.
 * Returns status and reason (OK, NO_SUBSCRIPTION, MACHINE_MISMATCH, TENANT_SUSPENDED).
 */
export function useLicensingCheck(productCode: string | undefined, enabled = true) {
  const code = productCode ?? '';
  const query = useQuery({
    queryKey: ['licensing-check', code],
    queryFn: () => saasApi.checkLicensing(code),
    enabled: Boolean(enabled && productCode),
  });

  const state: LicensingCheckState | undefined = query.data
    ? {
        allowed: query.data.allowed,
        reason: query.data.reason,
        productCode: query.data.productCode,
      }
    : undefined;

  return {
    ...query,
    state,
    allowed: state?.allowed ?? false,
    reason: state?.reason,
  };
}
